import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@orijinworks/frontend-commons';
import {
  templateAutocompleteSx,
  useTemplateDropdownStyles,
} from './TemplateDropdown.styles';

/**
 * Template selector shown when "Start from a template" is selected.
 */
export const TemplateDropdown = ({
  templates,
  selectedTemplate,
  onTemplateChange,
}) => {
  const classes = useTemplateDropdownStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.pointer} aria-hidden="true" />
      <Box className={classes.field}>
        <Autocomplete
          className={classes.autocompleteRoot}
          PaperProps={{ className: classes.paper }}
          ListboxProps={{
            className: classes.listbox,
          }}
          options={templates}
          value={selectedTemplate}
          disableClearable
          getOptionLabel={(option) => option?.name || ''}
          isOptionEqualToValue={(option, selected) => option?.id === selected?.id}
          onChange={(_, nextValue) => onTemplateChange(nextValue)}
          renderOption={(option) => (
            <Box className={classes.optionContent}>{option?.name || ''}</Box>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Template"
              variant="outlined"
              InputLabelProps={{
                ...params.InputLabelProps,
                shrink: true,
              }}
              sx={templateAutocompleteSx}
            />
          )}
        />
      </Box>
    </Box>
  );
};

TemplateDropdown.propTypes = {
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  selectedTemplate: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  onTemplateChange: PropTypes.func.isRequired,
};

TemplateDropdown.defaultProps = {
  templates: [],
  selectedTemplate: null,
};

export default TemplateDropdown;
